import { request } from './client';

/** What a report carries besides the person's words — so it can be acted on without a reply. */
export interface ProblemReport {
  message: string;
  page?: string;
  projectId?: string;
  appId?: string;
  lastError?: string;
  /** Only for somebody not signed in: where to answer them. */
  contact?: string;
}

/**
 * POST /feedback. Kept on the server whether or not anybody is emailed (infra/lambda/handlers/
 * feedback.ts), so "sent" here means it is recorded. Throws the server's sentence on a refusal.
 */
export async function reportProblem(report: ProblemReport): Promise<void> {
  await request('/feedback', { method: 'POST', base: 'api', body: report });
}
